require('./bootstrap');
window.App = {
    webRoot : '/',

    buttons_to_reset : [],

    resetButtons : function(){
        $.each(App.buttons_to_reset,function(){
            this.button('reset');
        });
    },

    bindEvent : function(eventName, events, callback){
        $(document).on(events,'.js-evbind-'+eventName, callback);
    },

    loadContentViaAjax : function(url, settings, selector, contentCallback = null){
        var target = $(selector);
        target.children().fadeOut(500);
        
        var loader = $('<div></div>').addClass('loader');
        target.html(loader);

        $.ajax(url,settings).done(function(response){
            let content = $('<div/>').html(response);
            if(contentCallback)
                contentCallback(response);
            target.html(content.contents());
            target.find($("script[data-type=eval]")).each(function(i, v) {
                eval($(this).text());
            });
            App.processAnistiaRenderedScript();

        }).fail(function(response){
            let messageBlock = $('<div>', {
               class: 'text-center',
            });

            $('<div>', {
                class: 'alert alert-danger',
                text: 'Ocorreu um erro, por favor, cheque sua conexão com a internet ou tente novamente mais tarde.',
            }).css('white-space', 'normal').appendTo(messageBlock);

            $('<button>', {
               class: 'btn btn-responsive text-pink',
               text: 'ATUALIZAR'
            }).click(function() {
                location.reload();
            }).appendTo(messageBlock);

            target.html(messageBlock);

            App.processAnistiaRenderedScript();
        });
    },
    processAnistiaRenderedScript: function(){
        let $t=document.querySelector("#anistiaInternacionalScript");
        if($t && $t.getAttribute('render-load')!="loaded") {
            $t.setAttribute("render-load", "loaded");
            let scriptMe = document.createElement('script');
            if ($t.src.length > 0) scriptMe.setAttribute('src', $t.src);

            scriptMe.text = $t.innerHTML;
            document.head.appendChild(scriptMe);
        }
    },
    init : function(){
        Facebook.init();
        $('[data-toggle="popover"]').popover();
    },

    reloadMenu : function(){
        let $menu=$('#main-menu');

        var url = App.webRoot + 'getMenu';

        $.get(url+($menu.hasClass('navbar-home')?"?isHome":"")).done(function(response){
            $menu.remove();
            var content = $('<div/>').html(response);

            $('body').prepend(content.contents());
        });
    }
};

$(function(){
    App.init();

    App.bindEvent('toggle_popover','click',function(ev){
        var popover = $(ev.target);
        popover.popover('toggle');
    });
});
// UTILS
require('./utils');

// VALIDATORS
require("./validators/form-generic-validator");
require("./validators/sidebarform");
require("./validators/paymenttab");
require("./validators/jquery.validators");

// "Components"
require('./user');
require('./facebook');
require('./components/pageHeightControl');
require('./components/goTop');
require('./components/asyncImage');
require('./components/bs-form');
require('./components/bs-button');
require('./components/liveSum');
require('./components/cep-autofill');
require('./components/cookie-consent')

// PAGES
require('./pages/project-page');
require('./pages/index-page');
require('./pages/cadastro-pf');
require('./pages/cadastro-pj');
require('./pages/recupera-senha');
require('./pages/altera-senha');
require('./pages/campaigns');
require('./pages/perfil');
require('./pages/arrecade-pontual');
require('./pages/arrecade-new');
require('./pages/boleto-estorno');
require('./pages/boleto-estorno-moip');
require('./pages/campanha-recompensas/store');
require('./pages/campanha-recompensas/index');
require('./pages/project-flex-create');
require('./pages/especial/quadrinhos');